import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import MovementsTable from './MovementsTable';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import PaginationInfo from 'CommonComponents/PaginationInfo';
import TablePagination from 'CommonComponents/TablePagination';

/**
 * One department's or cost centre's contingency ledger, for the Movements tab on
 * its own screen. Read-only: the balance is edited on Budget Change Management.
 */
export default function LocationMovements(props) {
    const [loading, setLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [meta, setMeta] = useState({ current_page: 1, last_page: 1, total: 0, per_page: 50 });
    const [closingBalance, setClosingBalance] = useState(null);
    const [page, setPage] = useState(1);

    useEffect(() => {
        setLoading(true);

        // No date-range filter here: a department or cost centre record belongs to one
        // budget version, so its whole history is already version-scoped and an
        // all-time range is the same set of rows.
        axios
            .get(`${props.movementsUrl}?page=${page}`)
            .then((res) => {
                setRows(res.data.rows);
                setMeta(res.data.meta);
                setClosingBalance(res.data.closing_balance ?? null);
            })
            .finally(() => setLoading(false));
    }, [props.movementsUrl, page]);

    if (loading) {
        return <LoadingSpinner />;
    }

    const rangeFrom = meta.total === 0 ? 0 : (meta.current_page - 1) * meta.per_page + 1;
    const rangeTo = Math.min(meta.current_page * meta.per_page, meta.total);

    return (
        <div className="table__card tw-flex tw-flex-col tw-gap-4">
            <h4 className="table__header">{$t('Contingency movements')}</h4>

            <div className="tw-flex tw-items-center tw-space-x-3">
                <PaginationInfo from={rangeFrom} to={rangeTo} total={meta.total} />
                <TablePagination lastPage={meta.last_page} currentPage={meta.current_page} pageChange={(data) => setPage(data.selected + 1)} />
            </div>

            <MovementsTable rows={rows} closingBalance={closingBalance} showContingencyColumn={false} />
        </div>
    );
}

if (document.getElementById('LocationContingencyMovements')) {
    const rootEl = document.getElementById('LocationContingencyMovements');
    ReactDOM.render(
        <App>
            <LocationMovements movementsUrl={rootEl.dataset.movementsUrl} />
        </App>,
        rootEl,
    );
}
